import script from "./OkrTimelinesTableHead.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrTimelinesTableHead.vue?vue&type=script&setup=true&lang=js"

import "./OkrTimelinesTableHead.vue?vue&type=style&index=0&id=74c14788&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c14788"]])

export default __exports__